import { ACTION_TYPES } from './firstCustomer.actions';
import { IFirstCustomer, defaultValue } from '../../model/firstCustomer.model';

export type firstCustomerState = Readonly<IFirstCustomer>;

const initialState: firstCustomerState = defaultValue;

export default (state: firstCustomerState = initialState, action): firstCustomerState => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_CUSTOMER:
      return {
        ...state,
        ...action.payload // Met à jour uniquement les champs fournis
      };
    case ACTION_TYPES.RESET_CUSTOMER:
      return initialState; // Réinitialise tout l'état

    case ACTION_TYPES.ADD_BENEFICIARY:
      return {
        ...state,
        beneficiaries: [...state.beneficiaries, action.payload] // Ajoute un nouveau bénéficiaire
      };

    case ACTION_TYPES.REMOVE_BENEFICIARY:
      return {
        ...state,
        beneficiaries: state.beneficiaries.filter((beneficiary, index) => index !== action.payload) // Supprime un bénéficiaire par index
      };

    case ACTION_TYPES.UPDATE_BENEFICIARY:
      return {
        ...state,
        beneficiaries: state.beneficiaries.map((beneficiary, index) =>
          index === action.payload.index ? { ...beneficiary, ...action.payload.updates } : beneficiary
        ) // Met à jour un bénéficiaire par index
      };

    default:
      return state;
  }
};
